var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "majesticons:delete-bin-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.50016 5.83337C7.50016 5.17033 7.76355 4.53445 8.2324 4.06561C8.70124 3.59677 9.33712 3.33337 10.0002 3.33337C10.6632 3.33337 11.2991 3.59677 11.7679 4.06561C12.2368 4.53445 12.5002 5.17033 12.5002 5.83337M7.50016 5.83337H12.5002M7.50016 5.83337H5.00016M12.5002 5.83337H15.0002M5.00016 5.83337H3.3335M5.00016 5.83337V15C5.00016 15.4421 5.17576 15.866 5.48832 16.1786C5.80088 16.4911 6.2248 16.6667 6.66683 16.6667H13.3335C13.7755 16.6667 14.1994 16.4911 14.512 16.1786C14.8246 15.866 15.0002 15.4421 15.0002 15V5.83337M15.0002 5.83337H16.6668",
    stroke: "#FF4D42",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.0a9fe4513d0a45150ba2f1a450778d8a.svg";
export { ForwardRef as ReactComponent };